import { Navigate } from "react-router-dom";
import {
  hasPermission,
  getFirstAllowedAdminPage,
} from "../utils/permissions";
import PermissionDenied from "../components/PermissionDenied";
import { useAuth } from "./AuthContext";


export default function PermissionGuard({ permission, children }) {
  const { loading, permissions } = useAuth();

  if (loading) return null;

  if (!hasPermission(permissions, permission)) {
    const fallbackPath = getFirstAllowedAdminPage(permissions);

    return (
      <PermissionDenied
        fallbackPath={fallbackPath}
      />
    );
  }

  return children;
}